import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView } from "../services/ActivityTracker";

const ActivityRouteListener = () => {
	const location = useLocation();
	useEffect(() => {
		trackPageView(location.pathname);
	}, [location.pathname]);
	return null;
};

export default ActivityRouteListener;
